const users = {
    Administrador:true,
    Vendedor:false,
    Almacen:false,
    Operaciones:false,
    Marketing:false,
    "Servicio al cliente":false,
    Finance: true,
    Courier: false
}

const sales = {
    Administrador:true,
    Vendedor:true,
    Almacen:false,
    Operaciones:false,
    Marketing:false,
    "Servicio al cliente":true,
    Finance: true,
    Courier: false
}

const orders = {
    Administrador:true,
    Vendedor:true,
    Almacen:true,
    Operaciones:true,
    Marketing:false,
    "Servicio al cliente":true,
    Finance: true,
    Courier: false
}

const customers = {
    Administrador:true,
    Vendedor:false,
    Almacen:false,
    Operaciones:false,
    Marketing:true,
    "Servicio al cliente":true,
    Finance: true,
    Courier: false
}

const products = {
    Administrador:true,
    Vendedor:false,
    Almacen:true,
    Operaciones:true,
    Marketing:false,
    "Servicio al cliente":false,
    Finance: true,
    Courier: false
}

const stats = {
    Administrador:true,
    Vendedor:true,
    Almacen:true,
    Operaciones:true,
    Marketing:true,
    "Servicio al cliente":false,
    Finance: true,
    Courier: false
}

const salesStats = {
    Administrador:true,
    Vendedor:true,
    Almacen:false,
    Operaciones:false,
    Marketing:false,
    "Servicio al cliente":false,
    Finance: true,
    Courier: false
}

const storeStats = {
    Administrador:true,
    Vendedor:false,
    Almacen:true,
    Operaciones:true,
    Marketing:false,
    "Servicio al cliente":false,
    Finance: true,
    Courier: false
}

const marketingStats = {
    Administrador:true,
    Vendedor:false,
    Almacen:false,
    Operaciones:false,
    Marketing:true,
    "Servicio al cliente":false,
    Finance: true,
    Courier: false
}

const financeStats = {
    Administrador:true,
    Vendedor:false,
    Almacen:false,
    Operaciones:false,
    Marketing:true,
    "Servicio al cliente":false,
    Finance: true,
    Courier: false
}

const operationStats = {
    Administrador:true,
    Vendedor:false,
    Almacen:true,
    Operaciones:true,
    Marketing:false,
    "Servicio al cliente":false,
    Finance: true,
    Courier: false
}

const store = {
    Administrador:true,
    Vendedor:false,
    Almacen:true,
    Operaciones:false,
    Marketing:false,
    "Servicio al cliente":false,
    Finance: true,
    Courier: false
}

const config = {
    Administrador:true,
    Vendedor:true,
    Almacen:true,
    Operaciones:true,
    Marketing:true,
    "Servicio al cliente":false,
    Finance: true,
    Courier: false
}

const editOrders = {
    Administrador:true,
    Vendedor:false,
    Almacen:false,
    Operaciones:true,
    Marketing:false,
    "Servicio al cliente":true,
    Finance: false,
    Courier: false
}

const auditing = {
    Administrador:true,
    Vendedor:false,
    Almacen:false,
    Operaciones:false,
    Marketing:false,
    "Servicio al cliente":false,
    Finance: true,
    Courier: false
}

const editSaleChannels = {
    Administrador:true,
    Vendedor:false,
    Almacen:false,
    Operaciones:false,
    Marketing:false,
    "Servicio al cliente":true,
    Finance: true,
    Courier: false
}

const courierStats = {
    Administrador:true,
    Vendedor:false,
    Almacen:false,
    Operaciones:false,
    Marketing:false,
    "Servicio al cliente":false,
    Finance: false,
    Courier: true
}

const customerServiceRead = {
    Administrador:true,
    Vendedor:true,
    Almacen:false,
    Operaciones:true,
    Marketing:false,
    "Servicio al cliente":true,
    Finance: false,
    Courier: false
}

const customerServiceWrite = {
    Administrador:true,
    Vendedor:false,
    Almacen:false,
    Operaciones:true,
    Marketing:false,
    "Servicio al cliente":true,
    Finance: false,
    Courier: false
}

const sections = {
    users,
    sales,
    orders,
    customers,
    products,
    stats,
    salesStats,
    storeStats,
    marketingStats,
    operationStats,
    store,
    config,
    editOrders,
    auditing,
    editSaleChannels,
    financeStats,
    courierStats,
    customerServiceRead,
    customerServiceWrite
}

export const checkAccess = (section,role) => {
    if(section && role){
        return sections[`${section}`][`${role}`];
    }else{
        return;
    }
}